<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Notice</li>
      </ol>
    </nav>
    <div>
      <button type="button" class="btn btn-success w-150 fr mb-10" @click="register">등록</button>
      <table class="list">
        <colgroup>
          <col width="2">
          <col width="20">
          <col width="8">
          <col width="5">
        </colgroup>
        <thead>
        <tr>
          <td></td>
          <td>제목</td>
          <td>작성일</td>
          <td></td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in listData" :key="item.SQ">
          <td>{{ pageResult.listCount - (pageResult.pageNo - 1)*perPage - index }}</td>
          <td @click="showDetail(item)">{{ item.TITLE }}</td>
          <td class="tc">{{ item.REG_DTT }}</td>
          <td class="tr"><button type="button" class="btn btn-secondary btn-sm w-50" @click="deleteItem(item)">삭제</button></td>
        </tr>
        <tr v-if="!listData || listData.length === 0">
          <td></td>
          <td>등록된 항목이 없습니다</td>
          <td></td>
          <td></td>
        </tr>
        </tbody>
      </table>
      <div class="tc mt-20">
        <pagination :result="pageResult" @go="changePage"/>
      </div>
    </div>
    <popup v-if="edit">
      <div class="panel">
        <div class="close" @click="closeDetail()"></div>
        <form name="postForm" action="/api/admin/board" method="post" enctype="multipart/form-data" @submit.prevent="save">
          <input v-if="detailItem.SQ" name="SQ" v-model="detailItem.SQ" type="hidden">
          <input name="TYPE" type="hidden" value="NOTICE">
          <div class="cont">
            <h1 class="mb-20">공지사항 {{ detailItem.SQ ? '수정' : '등록' }}</h1>
            <table class="detail">
              <colgroup>
                <col width="5">
                <col width="20">
              </colgroup>
              <tbody>
              <tr>
                <th>상단고정</th>
                <td>
                  <input type="hidden" name="FIXED" v-model="detailItem.FIXED">
                  <label><input type="checkbox" :checked="detailItem.FIXED === 1" @click="detailItem.FIXED = detailItem.FIXED === 0 ? 1 : 0"> 상단고정</label>
                </td>
              </tr>
              <tr>
                <th>제목</th>
                <td><input type="text" name="TITLE" v-model="detailItem.TITLE"></td>
              </tr>
              <tr>
                <th>내용</th>
                <td><textarea name="CONT" v-model="detailItem.CONT"></textarea></td>
              </tr>
              </tbody>
            </table>
            <div class="tc mt-20">
              <button type="button" class="btn btn-success w-200" @click="save">저장</button>
            </div>
          </div>
        </form>
      </div>
    </popup>
  </div>
</template>

<style lang="less" scoped>
  @import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
  @import '../../less/asset';
  @import '../../less/gynpad';
  @import '../../less/admin';
</style>

<script>
import axios from 'axios';
import handler from '../../util/ErrorHandler';
import Pagination from '../../components/admin/pagination.vue';
import DropFileInput from '../../components/admin/DropFileInput.vue';
import Popup from '../../components/Pop.vue';
import oxizen from '../../util/oxizen';

export default{
  name: 'News',
  components: { Pagination, DropFileInput, Popup },
  data() {
    return {
      listData: null,
      pageResult: null,
      pageNo: 1,
      perPage: 15,
      detailItem: null,
      edit: false,
    };
  },
  mounted() {
    this.updateList();
  },
  methods: {
    updateList() {
      axios.get('/api/admin/board', { params: { pageNo: this.pageNo, perPage: this.perPage, TYPE: 'NOTICE' } })
        .then(({ data }) => {
          if (data.result === 'no-grant') {
            window.location.href = '/admin/login';
            return;
          }
          this.listData = data.list;
          this.pageResult = data.paging;
        })
        .catch(handler());
    },
    changePage(page) {
      this.pageNo = page;
      this.updateList();
    },
    showDetail(item) {
      this.detailItem = item;
      this.edit = true;
    },
    closeDetail() {
      this.edit = false;
    },
    deleteItem(item) {
      if (window.confirm('정말 삭제하시겠습니까?')) {
        axios.get('/api/admin/boardDelete', { params: { SQ: item.SQ } })
          .then(() => {
            alert('삭제되었습니다');
            this.updateList();
          })
          .catch(handler());
      }
    },
    save() {
      oxizen.submit('postForm')
        .then(() => {
          alert('저장되었습니다');
          this.closeDetail();
          this.updateList();
        })
        .catch(({ status }) => {
          if (status === 'no-grant') {
            window.location.href = '/admin/login';
          }
        });
    },
    register() {
      this.detailItem = { FIXED: 0 };
      this.edit = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/admin/Notice.vue